import { render } from "./ProductAddModal.vue?vue&type=template&id=70f87012&scoped=true"
import script from "./ProductAddModal.vue?vue&type=script&lang=js"
export * from "./ProductAddModal.vue?vue&type=script&lang=js"

import "./ProductAddModal.vue?vue&type=style&index=0&id=70f87012&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f87012"]])

export default __exports__